import { http } from '@/utils/http';
import qs from 'qs';

const voteName = '2020project/2020civilized';

// 列表
export const getlist = (page: any, type: any, search?: any) => {
  // const qsData = qs.stringify(data);
  return http.post(
    '/vote/2020project/2020civilized/controller.php?enews=vote-list&page=' +
      page +
      '&work_type=' +
      type +
      '&search=' +
      search,
  );
};

// 获取详情页数据
export const getDetailData = (id: number) => {
  return http.get(
    '/vote/2020project/2020civilized/controller.php?enews=detail&id=' + id,
  );
};
// 提交数据
export const saveData = (data?: any) => {
  const qsData = qs.stringify(data);
  return http.post(
    '/vote/2020project/2020civilized/controller.php?enews=save',
    qsData,
  );
};
// 获取活动规则数据
export const getRules = () => {
  return http.post(
    '/vote/2020project/2020civilized/controller.php?enews=rules',
  );
};
